export const storageCategories = {
	"24Hour": [
		"climate",
		"driveUp",
		"business",
		"vehicle",
		"electricity",
		"car",
		"motorcycle",
		"rv"
	],
	climate: [
		"driveUp",
		"24Hour",
		"selfStorage",
		"vehicle",
		"rv",
		"car",
		"truck",
		"jetSki"
	],
	driveUpAccess: [
		"vehicle",
		"car",
		"boat",
		"rv",
		"motorcycle",
		"business",
		"climate",
		"24Hour"
	],
	portableStorage: [
		"climate",
		"24Hour",
		"driveUp",
		"college",
		"military",
		"business",
		"car",
		"rv"
	],
	electricityStorage: [
		"climate",
		"24Hour",
		"driveUp",
		"car",
		"business",
		"rv",
		"wine",
		"motorcycle"
	],
	wineStorage: [
		"climate",
		"driveUp",
		"electricity",
		"24Hour",
		"business",
		"portable",
		"car",
		"rv"
	],
	collegeStudent: [
		"vehicle",
		"car",
		"bicycle",
		"motorcycle",
		"portable",
		"24Hour",
		"driveUp",
		"electricity"
	],
	business: [
		"climate",
		"24Hour",
		"driveUp",
		"electricity",
		"portable",
		"wine",
		"vehicle",
		"car"
	],
	military: [
		"portable",
		"vehicle",
		"car",
		"motorcycle",
		"climate",
		"24Hour",
		"driveUp",
		"business"
	],
	atv: [
		"vehicle",
		"motorcycle",
		"dirtBike",
		"rv",
		"golfCart",
		"driveUp",
		"24Hour",
		"electricity"
	],
	bicycle: [
		"vehicle",
		"motorcycle",
		"kayak",
		"dirtBike",
		"college",
		"24Hour",
		"climate",
		"electricity"
	],
	boat: [
		"rv",
		"jetSki",
		"kayak",
		"vehicle",
		"car",
		"truck",
		"driveUp",
		"24Hour"
	],
	car: [
		"rv",
		"boat",
		"vehicle",
		"jetSki",
		"kayak",
		"24Hour",
		"driveUp",
		"climate"
	],
	dirtBike: [
		"motorcycle",
		"atv",
		"vehicle",
		"driveUp",
		"24Hour",
		"climate",
		"truck",
		"boat"
	],
	golfCart: [
		"vehicle",
		"car",
		"atv",
		"motorcycle",
		"driveUp",
		"24Hour",
		"climate",
		"rv"
	],
	jetSki: [
		"vehicle",
		"boat",
		"kayak",
		"rv",
		"car",
		"driveUp",
		"24Hour",
		"climate"
	],
	kayak: [
		"vehicle",
		"boat",
		"jetSki",
		"bicycle",
		"rv",
		"24Hour",
		"driveUp",
		"climate"
	],
	motorcycle: [
		"vehicle",
		"car",
		"atv",
		"dirtBike",
		"bicycle",
		"climate",
		"24Hour",
		"electricity"
	],
	rv: [
		"car",
		"truck",
		"boat",
		"jetSki",
		"kayak",
		"dirtBike",
		"golfCart",
		"driveUp"
	],
	truck: [
		"car",
		"rv",
		"boat",
		"jetSki",
		"vehicle",
		"climate",
		"24Hour",
		"driveUp"
	],
	vehicle: [
		"car",
		"motorcycle",
		"rv",
		"boat",
		"truck",
		"driveUp",
		"climate",
		"24Hour"
	],
	selfStorage: [
		"vehicle",
		"climate",
		"driveUp",
		"24Hour",
		"boat",
		"car",
		"rv",
		"college"
	]
};
